import { RouteObject } from "react-router";
import { setupMakePaymentRoutes } from "src/router/routes/common/MakePayment";
import { SigningRoute, VoidSignedDocumentRoute } from "src/router/routes/jobs/Signatures";

export const ContractsRoutes: RouteObject[] = [
  {
    path: ":estimateId",
    async loader(args) {
      const { contractLoader } = await import("src/router/loaders/jobs/Estimates");
      return contractLoader(args);
    },
    async lazy() {
      const { ContractDocsList } = await import("jobs/Job/ContractsTab/ContractDocsList");
      return { element: <ContractDocsList /> };
    },

    children: [
      SigningRoute,
      VoidSignedDocumentRoute,
      {
        path: "email",
        async lazy() {
          const { EmailEstimate } = await import("jobs/components/EmailEstimate");
          return { element: <EmailEstimate docType="contract" /> };
        },
      },
      ...setupMakePaymentRoutes(),
    ],
  },
  {
    path: ":estimateId/view_pdf/:documentId",
    shouldRevalidate: ({ currentParams, nextParams }) => currentParams.estimateId !== nextParams.estimateId,
    async loader(args) {
      const { contractPdfViewLoader } = await import("src/router/loaders/jobs/Estimates");
      return contractPdfViewLoader(args);
    },
    async lazy() {
      const { ViewContractDoc } = await import("jobs/Job/ContractsTab/ViewContractDoc");
      return {
        element: <ViewContractDoc />,
      };
    },
    children: [
      {
        path: "email",
        async lazy() {
          const { EmailEstimate } = await import("jobs/components/EmailEstimate");
          return {
            element: <EmailEstimate docType="contract" />,
          };
        },
      },
      {
        path: "signature",
        /**
         * Contract-signing route for the active PDF.
         *
         * Intentionally leaves `shouldRevalidate` unset so direct entry/refresh always reloads the PDF
         * from the current contract state. This avoids serving stale content after the document was
         * regenerated for a new draft or re-validated for a saved one.
         *
         * The modal flow does not fire router actions, so this loader only re-runs on real navigation,
         * which keeps the cost bounded and predictable.
         */
        async loader(args) {
          const { contractSignatureLoader } = await import("src/router/loaders/jobs/Estimates");
          return contractSignatureLoader(args);
        },
        async lazy() {
          const { ContractSignature } = await import("jobs/Job/ContractsTab/ContractSignature");
          return { element: <ContractSignature /> };
        },
      },
      ...setupMakePaymentRoutes(),
    ],
  },
  {
    path: "",
    async loader(args) {
      const { contractsLoader } = await import("src/router/loaders/jobs/Estimates");
      return contractsLoader(args);
    },
    async lazy() {
      const { ContractsTab } = await import("jobs/Job/ContractsTab");
      return { element: <ContractsTab /> };
    },
  },
  ...setupMakePaymentRoutes(),
];
